import { MapPin } from 'lucide-react'
import { openStreetMapEmbedUrl } from '../domain/mapPreview'
import type { LocationData } from '../domain/qr'

interface MapPreviewProps {
  data: LocationData
  label: string
}

export function MapPreview({ data, label }: MapPreviewProps) {
  const embedUrl = openStreetMapEmbedUrl(data)
  if (!embedUrl) {
    return (
      <div className="relative flex min-h-52 items-center justify-center overflow-hidden bg-base-200" aria-label={label}>
        <div className="absolute inset-0 opacity-50" style={{ backgroundImage: 'linear-gradient(var(--color-base-300) 1px, transparent 1px), linear-gradient(90deg, var(--color-base-300) 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
        <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-neutral text-neutral-content shadow-xl">
          <MapPin size={34} aria-hidden="true" />
        </div>
      </div>
    )
  }

  return (
    <div className="relative min-h-52 overflow-hidden bg-base-200">
      <iframe
        className="absolute inset-0 h-full w-full border-0"
        src={embedUrl}
        title={label}
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      />
    </div>
  )
}
